import React, { Component } from "react";
import { alertActions } from '../../action/AlertAction';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { accountActions } from "../../action/AccountAction";
import { commonClass } from "../../helpers/commonClass";
import { Helmet } from "react-helmet";
// import countrycode from '../Home/countrycode.json';

class Refferal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            Pending: 1,
            Success: 2,
            copied: false,
        };
        this.inputRef = React.createRef();
    }

    handleInputChange = (event) => {
        this.setState({ copyText: event.target.value });
    };


    handleCopyClick = () => {
        const node = this.inputRef.current;
        if (!node) return;

        const range = document.createRange();
        range.selectNodeContents(node);
        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);

        try {
            const successful = document.execCommand('copy');
            if (successful) {
                this.setState({ copied: true });
                setTimeout(() => this.setState({ copied: false }), 2000);
            } else {
                console.error('Copy command was unsuccessful');
            }
        } catch (err) {
            console.error('Fallback: Copy command failed', err);
        }

        // Deselect the text
        window.getSelection().removeAllRanges();
    };
    handleEmailClick = () => {
        const link = `${process.env.REACT_APP_DESKTOP_URL}?plyrid=${this.props.user.referralid}`;
        window.location.href = `mailto:?subject=Referral Link&body=Here is my referral link: ${link}`;
    };
    handleWhatsAppClick = () => {
        const link = `${process.env.REACT_APP_DESKTOP_URL}?plyrid=${this.props.user.referralid}`;
        window.open(`https://wa.me/?text=${encodeURIComponent(link)}`, "_blank");
   };

   handleSMSClick = () => {
    const link = `${process.env.REACT_APP_DESKTOP_URL}?plyrid=${this.props.user.referralid}`;
    window.location.href = `sms:?body=Here is my referral link: ${link}`;
  };
    render() {
        const { t } = this.props;
        return (
            <>
                {process.env.REACT_APP_MODE != "development" && <Helmet>
                    <title>Gulf Ticket : Profile</title>
                    <meta name="description" content="Gulf Ticket Profile" />
                </Helmet>
                }
                <div class="myAccContHead">
                    <h1><img src="./assets/img/icons/tabs-referral.png" />{t("lblrefferalname")}</h1>
                </div>
                <div class="myAccContInfo">
                    <div class="referral">
                        <div class="referralCont">
                            <div class="referralLi">
                                <span>{t("lblrefferal")}</span>
                                <div ref={this.inputRef} class="refferLink">{`${process.env.REACT_APP_DESKTOP_URL}?plyrid=${this.props.user.referralid}`}</div>
                                <div class="copyBtn">
                                    <button onClick={() => { this.handleCopyClick() }}><img src="./assets/img/icons/copy.png" />Copy</button>
                                    {this.state.copied && (
                                        <span style={{ marginLeft: '10px', color: 'green' }}>Copied!</span>
                                    )}
                                </div>
                            </div>
                            <div class="referralBtns">
                                <button onClick={this.handleEmailClick}><img src="./assets/img/icons/email.png" />Email</button>
                                <button onClick={this.handleWhatsAppClick}><img src="./assets/img/icons/whatsapp.png" />WhatsApp</button>
                                <button onClick={this.handleSMSClick}><img src="./assets/img/icons/sms.png" />SMS</button>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
function mapStateToProps(state) {
    const { user, appvariables } = state.loginReducer;
    return { user, appvariables };
}
const mapActionToProps = {
    alertError: alertActions.error,
}
export default connect(mapStateToProps, mapActionToProps)(withTranslation()(Refferal))